// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Select {
  height: 40px;
  width: 18vw;
  color: #000000;
  font-family: "Montserrat Regular";
  font-weight: 400;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/EstablishmentsUpdatePage/Tabs/ClientControlPage/Select/Select.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;AACF","sourcesContent":[".Select {\n  height: 40px;\n  width: 18vw;\n  color: #000000;\n  font-family: 'Montserrat Regular';\n  font-weight: 400; \n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Select": `Select`
};
export default ___CSS_LOADER_EXPORT___;
